import type { LocaleEnum } from "@/services/internalApiV1";

// Each interface language in its own language, whatever the UI language is,
// so a user can find theirs on a UI they can't read (#13769).
export const LOCALE_ENDONYMS: Record<LocaleEnum, string> = {
  de: "Deutsch",
  en: "English",
  fr: "Français",
  nl: "Nederlands",
};
